/* eslint-disable prefer-arrow-callback,no-var,comma-dangle */
(function videoCarousel() {
  var rootElement = null;
  var guid = false;
  var player = false;
  var windowWidth = window.innerWidth;
  var resizeTimer = null;

  // Append a className to an elem, if not already present
  function addClass(elem, className) {
    if (elem.className.indexOf(className) === -1) {
      elem.className = (elem.className + ' ' + className).trim(); // eslint-disable-line no-param-reassign, prefer-template, max-len
    }
  }

  // Remove a className from an elem, if present
  function removeClass(elem, className) {
    var classNames = elem.className.trim().split(' ');
    var removeClassNames = className.trim().split(' ');
    var newClassName = classNames
      .filter(function _filter(name) {
        return removeClassNames.indexOf(name) === -1;
      })
      .join(' ')
      .trim();
    elem.className = newClassName; // eslint-disable-line no-param-reassign
  }

  /* @findClosest
   * Helper to get the closest parent element matching a CSS selecor
   */
  function findClosest(element, selector) {
    while (
      !(
        element.matches || // eslint-disable-line no-cond-assign
        element.matchesSelector ||
        element.msMatchesSelector ||
        element.webkitMatchesSelector
      ).call(element, selector) &&
      (element = element.parentElement)
    ); // eslint-disable-line no-param-reassign
    return element;
  }

  /* @setActive
   * Remove active clas from all elements, and sets @param: (DOMNode) element active class
   */
  function setActive(element) {
    // Strip all active elements of active class
    Array.prototype.slice
      .apply(rootElement.querySelectorAll('.tc_videocarousel__carousel__item'))
      .forEach(function _stripActive(activeElement) {
        activeElement.classList.remove(
          'tc_videocarousel__carousel__item--active',
        );
      });

    // Apply actie class to new element
    element.classList.add('tc_videocarousel__carousel__item--active');
  }

  /* @getElementIndex
   * gets the parent index of @param: (DOMNode) element
   */
  function getElementIndex(element) {
    return [].indexOf.call(element.parentElement.children, element);
  }

  /* @getVisibleIndexes
   * gets the currently visible indexes
   */
  function getVisibleIndexes() {
    const listWidth = document.querySelector(
      '.tc_videocarousel__carousel__list',
    ).offsetWidth;
    const itemWidth = document.querySelector(
      '.tc_videocarousel__carousel__item',
    ).offsetWidth;
    return Math.floor(listWidth / itemWidth);
  }

  /* @offsetCurrentIndexBy
   * gets current index and offsets by @param: (int) val
   */
  function offsetCurrentIndexBy(val) {
    var listElement = rootElement.querySelector(
      '.tc_videocarousel__carousel__list',
    );
    var itemElement = rootElement.querySelector(
      '.tc_videocarousel__carousel__item',
    );
    var listLeft = listElement.scrollLeft;
    var itemWidth = itemElement.scrollWidth;
    var curIndex = Math.round(listLeft / itemWidth);

    return curIndex + val;
  }

  /* @scrollToIndex
   * Animate carousel list left scroll to a @param: (int) index
   */
  function scrollToIndex(index) {
    var listElement = rootElement.querySelector(
      '.tc_videocarousel__carousel__list',
    );
    var listItemElement = rootElement.querySelector(
      '.tc_videocarousel__carousel__item',
    );

    var scrollStart = listElement.scrollLeft;
    var scrollTarget = listItemElement.scrollWidth * index;
    var scrollChange = scrollTarget - scrollStart;
    var currentTime = 0;
    var increment = 20;
    var duration = 200;

    // easeOutSine
    var easeOutSine = function _easOutSine(t, b, c, d) {
      return c * Math.sin((t / d) * (Math.PI / 2)) + b;
    };

    // incrementally scroll to the index
    var animateScroll = function _animate() {
      currentTime += increment;
      if (currentTime < duration) {
        listElement.scrollLeft = easeOutSine(
          currentTime,
          scrollStart,
          scrollChange,
          duration,
        );
        window.requestAnimationFrame(animateScroll);
      } else {
        // Add snap to the list
        addClass(listElement, 'tc_videocarousel__carousel__list--snap');
        // End on the target
        listElement.scrollLeft = scrollTarget;
      }
    };

    // Remove snap from the list
    removeClass(listElement, 'tc_videocarousel__carousel__list--snap');
    // start animating
    animateScroll();
  }

  /* @switchVideo
   * Switches video guid to data-guid from @pram: (DOMNode) selectedElement.
   */
  function switchVideo(selectedElement) {
    var newGuid = selectedElement.getAttribute('data-guid');

    if (!newGuid || guid === newGuid) {
      return guid;
    }

    // Set the guid;
    guid = newGuid;
    if (player.playVideo) {
      player.playVideo(guid);
    } else {
      player.on('canPlayVideo', () => {
        player.playVideo(guid);
      })
    }

    return guid;
  }

  /* @setButtonVisibility
   * Sets button visibility based on item list scroll position
   */
  function setButtonVisibility(listElement) {
    var nextButton = rootElement.querySelector(
      '.tc_videocarousel__carousel__next',
    );
    var prevButton = rootElement.querySelector(
      '.tc_videocarousel__carousel__prev',
    );
    var leftDisabled = listElement.scrollLeft < 5;
    var rightDisabled =
      listElement.scrollLeft >
      listElement.scrollWidth - listElement.clientWidth - 5;

    // set disabled for prev
    if (leftDisabled) {
      addClass(prevButton, 'tc_videocarousel__carousel__prev--disabled');
    } else {
      removeClass(prevButton, 'tc_videocarousel__carousel__prev--disabled');
    }

    // set disabled for next
    if (rightDisabled) {
      addClass(nextButton, 'tc_videocarousel__carousel__next--disabled');
    } else {
      removeClass(nextButton, 'tc_videocarousel__carousel__next--disabled');
    }
  }

  /* @createVideoCarousel
   * initiates the video carousel and applies event listeners to UI elements.
   */
  function createVideoCarousel() {
    var listElement = rootElement.querySelector(
      '.tc_videocarousel__carousel__list',
    );
    var activeElement = rootElement.querySelector(
      '.tc_videocarousel__carousel__item--active',
    );
    var videoElement = window.document.querySelector('.tc_video__video');

    // If no active, set the first video to active
    if (!activeElement) {
      activeElement = rootElement.querySelector(
        '.tc_videocarousel__carousel__item',
      );
    }

    // or abort the initiation
    if (!activeElement) return;

    setActive(activeElement);

    // We should have a guid, otherwise abort initiation
    guid = activeElement.getAttribute('data-guid') || false;
    if (!guid) return;
    videoElement.setAttribute('data-guid', guid);

    window.tv2messages.onceWithTimeout(
      'brightcoveplayer.ready',
      1e10,
      function (playerInstance) {
        player = playerInstance;
        player.on('hook', function _playerEvt(event, data) {
          var currentElement = rootElement.querySelector(
            '.tc_videocarousel__carousel__item--active',
          );
          var nextElement = currentElement.nextElementSibling;
          if (data.isAd !== true && data.event === 'ended' && nextElement) {
            scrollToIndex(getElementIndex(nextElement));
            setActive(nextElement);
            switchVideo(nextElement);
          }
        });
      },
    );

    function handleEvent(event) {
      var listItem = findClosest(
        event.target,
        '.tc_videocarousel__carousel__item',
      );
      var nextButton = findClosest(
        event.target,
        '.tc_videocarousel__carousel__next',
      );
      var prevButton = findClosest(
        event.target,
        '.tc_videocarousel__carousel__prev',
      );

      // It fires a click event on the next button
      if (nextButton !== null) {
        scrollToIndex(offsetCurrentIndexBy(getVisibleIndexes()));
      }
      // It fires a click event on the previous button
      if (prevButton !== null) {
        scrollToIndex(offsetCurrentIndexBy(0 - getVisibleIndexes()));
      }

      // It fires a click event on the a list item
      if (listItem !== null) {
        scrollToIndex(getElementIndex(listItem));
        setActive(listItem);
        switchVideo(listItem);
      }
    }

    rootElement.addEventListener('click', function (e) {
      handleEvent(e);
    });
    rootElement.addEventListener('keydown', function (e) {
      if (e.keyCode == 13) {
        handleEvent(e);
      }
    });

    // It resizes the window
    window.addEventListener('resize', function _resize() {
      if (Math.abs(windowWidth - window.innerWidth) < 5) return;
      clearTimeout(resizeTimer);
      windowWidth = window.innerWidth;
      resizeTimer = setTimeout(function _resizeTimer() {
        scrollToIndex(offsetCurrentIndexBy(0));
      }, 300);
    });

    // Setup button visibility and scroll listener
    setButtonVisibility(listElement);
    listElement.addEventListener('scroll', function _scroll() {
      setButtonVisibility(listElement);
    });

    // add scroll snap to list
    addClass(listElement, 'tc_videocarousel__carousel__list--snap');
  }

  function domready() {
    rootElement = window.document.querySelector('.tc_videocarousel__carousel');
    if (rootElement) {
      createVideoCarousel();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', domready);
  } else {
    domready();
  }
})();
